import { useAccountContext } from 'application/providers/AccountProvider';
import { useBillingRepositoryInjector } from 'application/providers/DIContainerProvider';
import { useFeatureFlagsContext } from 'application/providers/FeatureFlagsProvider';

import { OrganizationDiscountStatus } from 'domain/api/graphql/generated';

interface UseRatesTableViewModel {
  isChangePricePlanAvailable: boolean;
  isPrimeDiscountAvailable: boolean;
  primeDiscountValue?: number;
}

const SBER_PRIME_SLUG = 'sber_prime';

const useRatesTableViewModel = (): UseRatesTableViewModel => {
  const { currentCompany } = useAccountContext();
  const { isChangePricePlanAvailable } = useFeatureFlagsContext();
  const { watchBillingInfo } = useBillingRepositoryInjector();

  const { discount } = watchBillingInfo(currentCompany!.id);

  const isPrimeDiscountAvailable =
    discount?.slug === SBER_PRIME_SLUG && discount.status === OrganizationDiscountStatus.InProgress;
  const primeDiscountValue = discount?.value;

  return {
    isChangePricePlanAvailable,
    isPrimeDiscountAvailable,
    primeDiscountValue,
  };
};

export default useRatesTableViewModel;
